import React from 'react'

import Gallery from './gallery.js'
import { Websites, Logotypes } from '../../../Icons'
import { FormattedMessage } from "gatsby-plugin-intl"
import './portfolio.scss'

export default props => {
    const websites = props.websites
    const logos = props.logos
    return (
        <section className="portfolio" id="portfolio">
            <div className="portfolio__headline">
                <h2>Portfolio</h2>
            </div>

            <Gallery headline={<FormattedMessage defaultMessage="Websites" id="portfolio.websites"/>} data={websites} name="websites" icon={ <Websites /> }  previewContent={true} />

            <Gallery headline={<FormattedMessage defaultMessage="Logos" id="portfolio.logos"/>} data={logos} icon={ <Logotypes /> } name="logos" previewContent={false}/>
            
        </section>
    )
}
